import { Component, ViewChild, HostListener } from '@angular/core';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent{

  @ViewChild('carousel') public el: any;

  @HostListener('swipeleft', ['$event']) public swipePrev(event: any) {
      this.el.previousSlide();
  }

  @HostListener('swiperight', ['$event']) public swipeNext(event: any) {
      this.el.nextSlide();
  }
  showGalleryOne = true;
  showGalleryTwo = false;
  showGalleryThree = false;

  source: string;
  constructor() { }

  showSectionOne(){
    this.showGalleryOne = true;
    this.showGalleryTwo = false;
    this.showGalleryThree = false;
  }

  showSectionTwo(){
    this.showGalleryOne = false;
    this.showGalleryTwo = true;
    this.showGalleryThree = false;
  }

  showSectionThree(){
    this.showGalleryOne = false;
    this.showGalleryTwo = false;
    this.showGalleryThree = true;
  }
  
  imageList = [
    {
      id: 1,
      source: 'https://lh3.googleusercontent.com/-t1DPhsbr6oJAdE86BUBI4CF_DNub2W8y1vOgytirtTJ9kZFzcfjdffDO27K0l76tOlzR8_YXUtZa7K_ByCYjMRzIFpQtHAW_BGhcbtMSj1LaA8bj4ucz1e2nHqKiKDSOW4r2Wym0sE=w1920-h1080'
    },
    {
      id: 4,
      source: 'https://lh3.googleusercontent.com/6PGQ3xiSdw-v6C2qKAghqu2i7MuVKi1ightuRBOA_2p4lHVoaufUJ07bZMbH3vWYs7b9GXoHUFOS9NE-MKpEfkHpFFH3pA8D4OBl6rzsm5FpHab70H3OjhYr58kyqlAGl9OdW9NNv7w=w1920-h1080'
    },
    {
      id: 5,
      source: 'https://lh3.googleusercontent.com/8wdogpEoZ_3Pa41j2Rcy9InhwZ8ylmV5Weji6km1_9XXg8k5FOsy3yPAp9DU3IqC0VNJEFDGRRMQyUpYHwqbOPsd_rx2iYLUFGKe7V5CelJc4jn0hdj9IqpSvP4kTMDIbXKWdi4q9I4=w1920-h1080'
    },
    {
      id: 7,
      source: 'https://lh3.googleusercontent.com/WzVybfjsn8obegffpC2MYowUm9wN_WZD78G_wsccNxxz8KwnVb572IeIt6uDRx9er8wrZ0mpOGQSQgDeyaAnjQBpvNHZcqz31vZIVneY0kCM4_9Hq3WybKL9hzaw-cVZPRVip4oVZ6M=w1920-h1080'
    },
    {
      id: 9,
      source: 'https://lh3.googleusercontent.com/TWGamkgP4ElK1EOAg2kML86HmaMN4FD7ykk50eNqv6-VvGcTtDzzmB8pw5-rSkRP4LefqXz7lhd97HUqYlERJCkaZ49rotsujXUZtKNjSGQBio2ErwJefqUCgKq1s8_hxexpM1dH0YY=w1920-h1080'
    },
    {
      id: 11,
      source: 'https://lh3.googleusercontent.com/MVLrGkt9m2J6zfdqt--31jEkmCjknf3DeFWVSf5o3H9VbgECgrGuGKWhwZbuG3yoFge16sc1M2aZWbQHkRJ7dQDMkPTHGHXamxZoukbvCNUuhULj8S_wlvK18k52SXsd1RGOKP6mWdo=w1920-h1080'
    },
    {
      id: 12,
      source: 'https://lh3.googleusercontent.com/IUw4LXyiOhG2sqxZccSCB9g47LbBZJRUSaV31k6nUSUlLLBg8Oy0U7MM61ys9xpNMeHbzcPN3R4lmztT-Lwy7CEdUrN1Jsg1gQ9ZBbSljjLN_GORbrRFC8IManzD5eiXX4kuUadac10=w1920-h1080'
    },
    {
      id: 15,
      source: 'https://lh3.googleusercontent.com/zrOBSJ6yov0FRooDuGprzNnsp1OvhtgIaRzwebHcfCEtb_9IoPPN9OKs4fXYcbB9h-N7YTU13-6yCvrobGLoHa8JySJ0aV_BIVRzZCGUFnj-K8dlzEdoO7U65bghpqRNL17ocT3j-kM=w1920-h1080'
    },
    {
      id: 16,
      source: 'https://lh3.googleusercontent.com/z8kkM5pXVY_zA1wMvYXzYU1EKiOr-af5AD-LWVp3c2K4JNWQB-yIaLgUQN1VF7ACNuIHM4Le9fbMXCmcNao5kX7xKQ15zoowKv5jC-_o3uqRItTmyeUTYVy60bIYTqAu3rHdtA9upT0=w1920-h1080'
    },
    {
      id: 17,
      source: 'https://lh3.googleusercontent.com/MA4XkkDmTXqljMfvLcR3guQydXNvTxxmApQI0Gsq1Lx_qwjknavy-Q43wMKs1a7dFlZDHIfBwviTx6f_QByy5EB4yHQCLGjfzQm_ZjjEje8zcHWwwsCPQz6V3QXoTfPWzmdHzhTKQ4k=w1920-h1080'
    },
    {
      id: 18,
      source: 'https://lh3.googleusercontent.com/cf7QwQn8KytW8a27qbEFUl0ouE4GREUsKHyebwL8R1eP49y_l8sFbt18DYFTjoNJEBpAgnFLKHBlLWsTymvIL7gH1JDEXMpB8VkFtpqeYXx2QL0G0VyA12_vpimsQt_RBvMZ_mL35PQ=w1920-h1080'
    },
    {
      id: 19,
      source: 'https://lh3.googleusercontent.com/oud-o5j5igG7IO86kQU7M1YkefolUUtXwpmrKaeS79WkyKNL1IsQS3j4PdMUB2AB-AVz7bFrvXtSckHObLXWSrU4fho1ELpZVqPEosO4NiRLb_EAHLQQg4gHxDd8lpgW9ZI6ah-rXis=w1920-h1080'
    },
    {
      id: 20,
      source: 'https://lh3.googleusercontent.com/p586WNJJJ_T3uGrLlVmURNvT9uGKYFlgUGVL-GmP54uSYU5aloV_LBhGqeFBIZqtA2ZV2fDE-WzgHOsnpDgom9czuTGDasAzun7veTaPntMk9gXul_r3xpU-oZh30zC87cMVTKUKKas=w1920-h1080'
    },
    {
      id: 21,
      source: 'https://lh3.googleusercontent.com/YTcwcDbttZ43EIedTppoiktcNk0g4X3iC0MOCXaGh5eNwo1JaVSUQh9p1kEW83se11EwVAZeWKHzW70VZjT-Di4suP3-lduZXwWALtFupK_eBvPU2YDVh1Qf59EBO2k0wX4U5bInXqE=w1920-h1080'
    },
    {
      id: 22, 
      source: 'https://lh3.googleusercontent.com/CNqo49CxA4tX_861nucRQsTjaKcf5aGzNzzz2sy55v4dFWAeF39B3DeJnmNU5MBNMM6DKiD79JIoPUlwULF_QMwfatWA4fp0RbnTXh5pR9kZkghXHf-e71XSot5_3n9L0j_Ot5bL68A=w1920-h1080'
    },
    {
      id: 24,
      source: 'https://lh3.googleusercontent.com/E803oDmJtn4dYYyNIpk2TyG0Xyr1TTExleL4rukj10XjCYH0vzRp0_CJQEUEBiTwMKplLAjSGJsGSAv-2KXnHKFxLwDJLyEc0FQgJA_5lbK04xpBuDjcMEfnylGj0_-200GbQY_srS8=w1920-h1080'
    },
    {
      id: 25,
      source: 'https://lh3.googleusercontent.com/tMAjg7xt6O72I3-8o_V4sbO82qHwFzEZ_hwcUkRqxrzgs86KpDw5OpTEhU9i8pmB6qN2Udbst8-XrlXHpHmQF_8x9MVL8Y35eZLszKEdiHcFoLCH84IYl4hFYnNgkMglhl6QNOgFtEs=w1920-h1080'
    },
    {
      id: 26,
      source: 'https://lh3.googleusercontent.com/I9CpZBu3QRQQVMeuLxrYtvOlTwEsPfiX6V7bz3N9AJ46CaKeTSftB6UsLVClOksCj9Nf3FVLd0xpfrApxdSE6jJ_-iEkTPPSAlJxlVcYmTJyXgF1Z4oyGbB8Cp0n_qchIr5naMzxuVU=w1920-h1080'
    }
  ];



imageList2 = [
  {
    id: 27,
    source: 'https://lh3.googleusercontent.com/cWmwUff3DSAlmZc4m6jzQrpIBxEzngXEwPALMlnP4APevMqw3HdfBsTzZHoHUK-4MGV8kXigkM9maWTdi9VObanzEWME8TCHFjVsRFO5SxP-UT7aZ9dZ88Hz2d4t7XXEIs6uzDHYAtE=w1920-h1080'
  },
  {
    id: 29,
    source: 'https://lh3.googleusercontent.com/WKYHEvLh_QWfKrwzOWA9LHI0qh3J-Zds84uPDFvG2wVsIYhZR43-rWLAUysFj9ZAhrHvn6AWxI4BOyVjXqT44afQe9BGbj6K8RR6O13vqss5Pr09jzm9hEJATe01Cq5NRQ7DwheGkKY=w1920-h1080'
  },
  {
    id: 30,
    source: 'https://lh3.googleusercontent.com/XoG6hqQcdaje7KKswq8MrAWZq238ZRAkAg-TrG0aOJkLmyHrD5hkf4ZcBQTUAMvO1Ft5yz14SoLEKaAPkjJw1tAau9J7z41oQtEZUuFSKop3RJsk4Va6BAsRnzHyMwfNI4a_276WxGo=w1920-h1080'
  },
  {
    id: 31,
    source: 'https://lh3.googleusercontent.com/jIQs6yhgvVlAU0nAWnOKekELNj9LEckq2i83HUkr7MbEpzHP27DB3emkNrNOpvu9rXnAQiscWmHzuMvyDOlUQliGNfOcPTquk9aPNbO2OU2lWV2iSsD4t95RFxwVKRp7slswru_c1pE=w1920-h1080'
  },
  {
    id: 32,
    source: 'https://lh3.googleusercontent.com/XuQm4CY1hb4wlzdEfKDF77WjGmN9sNoIPEBfQgoP_mOFIJeKn8yVp4SPKTK18hjWu_z73S8zs45I61UvV5UBLsJ4vRwEXZc6ZdCFa2ON54JyrP6XeJT2ZA2zy9096zWrLgFC8G_A31M=w1920-h1080'
  },
  {
    id: 33,
    source: 'https://lh3.googleusercontent.com/_q53T0ThNh6zAXqDmrTVbaiWFZo_g1Xr56i5KdIlG3m2Vt8nomN5gvjJyDrPCoymvLv9JOCbxs6Ra43oJHYO6bWaj3sMHNq_O2KoyL4at7mEbs24qQPXbWHfyiW67Se30sy5VT1Sipk=w1920-h1080'
  },
  {
    id: 34, 
    source: 'https://lh3.googleusercontent.com/amf0WODl76cLTQBOpDeY5lW8WWcw0bVA5HPS7J6ccXT61KMNV2aHOjIl_Jye97XfQk0eBi5g3epuRjenIh3-n1FvNRlEk28sX0nHpHz1qe8vZtkaLzFvLRExj_p5YsAkYtT3L1FNcIQ=w1920-h1080'
  },
  {
    id: 35,
    source: 'https://lh3.googleusercontent.com/0we2o7IFMrsv-ujN5EY7HNt3YCXwsKreIo0VhLt72fu1URnNgZWm6D_Fjt_ROWvo_11h32eeo8jzfY1OUhrfqJzJ7SgjLlDXfx7_FOUPVQU0e2kvvjEn4KODbDNIa8yYCFqK4uoKjPo=w1920-h1080'
  },
  {
    id: 36,
    source: 'https://lh3.googleusercontent.com/jlVeAPO3YDc2GElKLCp0DXFFOBUWjZ1MsygbNVM0pnW2twY1qj29kya2sMvnppilUEv0otKwuEbl6-uCjCTMd5fk3YsUZlykbOChh87jLFjYJkTQKoErWUZnKXY4J_RFM8OPRRoNuEU=w1920-h1080'
  },
  {
    id: 38,
    source: 'https://lh3.googleusercontent.com/YvjWWrQ35XYjGbOi2OtKo8LLQM6_VhbRaHTsljhLy_ZPZXhj-4G1iFCHb4fGZ4B4NIROS3ErjwxZAHSq64ldmMw6hIPZ0JaHpYfZp1kD6H1mPCZZUzVYI0PWvAHD7_7cVVoi7yW3tQw=w1920-h1080'
  },
  {
    id: 39,
    source: 'https://lh3.googleusercontent.com/9nmDrsLOrNORKf-K2uUHE3SPujuobwdGrzKPW44-ZmAgaE3kPJH5pvS0gT1PqLD3IF1-QKdeIkZCGzW0NOQCMJBaWu4RAnyGzOVpVAoWhWyp7ixqPPmKUVNgfUZytiDYH3Ua1HrASDE=w1920-h1080'
  },
  {
    id: 40,
    source: 'https://lh3.googleusercontent.com/dY_TyGa5NbtTZ8lWhGmIkBRMc_2kJ8NE4FHHEmFPKt9m4ESwaL_pJpAGgiC0rvJQX-e4gRUm5XkYzMNJr9MYVOzP2_SCOgehTDiz3CS84QK8Mz8IsGEpqRcMxI4nlHNqOvKFIU4NNLA=w1920-h1080'
  },
  {
    id: 41,
    source: 'https://lh3.googleusercontent.com/9lVmAhjrF0OfaTenW37YlER6v2d7D-O-7fbezxIJTjyLOysJaA5VJ8FVKLbxYHAbEZK2f6h4gt4QyelBDHb4tiPFqmGKtXexdrUYswrT-vOiYtT9zA-1WO8mKt7i2gxAc8dKBK8J6h4=w1920-h1080'
  },
  {
    id: 42,
    source: 'https://lh3.googleusercontent.com/Q2riYEzp-E-3HMBBVLJd69BsB9lCLDSmvCKC0F3nrVy5ap1ZcsC7CXr1JQXJ27wBDcBlAOjruiY6tBQnj_zSxqjadGcSCPIN3klunRCl4P3oKAlJGjXBE0GX-tCrvWI6tQ-FTjcOfo8=w1920-h1080'
  },
  {
    id: 45,
    source: 'https://lh3.googleusercontent.com/R13p1L-6-WBVeMRqNGonLp0k-Z_qjrEgep5iuHpTcJ32uJY9gIobks6c1VrCF9DKRpZ_Nb9uykHX_6bgeAnJD5GqbbKrPTDL7spdS2HhXPH4nYsABuMNC00Qks5YFllOlbdnwzlIOO4=w1920-h1080'
  },
  {
    id: 46,
    source: 'https://lh3.googleusercontent.com/YslJbzOUagJ4-NW_lFpWkQnvnV20IH2LO2RS_YmbrgyrTUioSbChbZ-Jpdh7BDoMGaX9SnI0x6EyKsGyY0It05Br_89sqQKCDGQZ9WDm_uk_ksTJ_Q1F92sUd0uajsJY0prFd0XN5R8=w1920-h1080'
  }
]

imageList3 = [
  {
    id: 48,
    source: 'https://lh3.googleusercontent.com/YWCqCpKabFUiTKjjD-6dEOg8qVJ5MSFHuVLmvfXZ3xCNd_bH1u2KmIeA4CiCaOUiX0QaQU5E9geWUnyd4Qtl5B5aal85Ydu_2Jj8RvPXnVSLQ0L-uYq_te7sdCKkvsEbIxnntJBnk9Q=w1920-h1080'
  },
  {
    id: 49,
    source: 'https://lh3.googleusercontent.com/zGXzLqEBm82Cg9_EenxJ072j1tqKCoGv-hd63BiIYXzVvWK1NSnEPnkMqNqYhKXx1BA6_4nMqhQTFcSFOyn10vZqNqBxNoxpNEBX5RBo7CnMuhfVNNcZ612Rz_iam5aRc3700ISJf5I=w1920-h1080'
  },
  {
    id: 52,
    source: 'https://lh3.googleusercontent.com/Z2gDG0dvNVbHauRdH2_XEGQEl3GL80WZimYFfUAkh0b1PPz99W2D5gWs3fhC20RRNDZX8LXytKSaD_OZ9LDKyFm-cZFKkNMHRfMisO39AJgf-1CCtBk5QHj6LEeUri99wa4W4OoeW9Q=w1920-h1080'
  },
  {
    id: 54,
    source: 'https://lh3.googleusercontent.com/6fDCmnrghTPb0HP76dkH8weBu5bRWwlAqQp1hM8bLHfM_fGU2lxa5_NbVzWZvtAbgzaSiT225f_RAhRZsawrdROXmXrjkI6PVDCuNpdikIAkbW0V3UNNi94t95W8u1kONcmVKe4PSKM=w1920-h1080'
  },
  {
    id: 55,
    source: 'https://lh3.googleusercontent.com/MNkgLVqfV6Z_vTdEkEzARxvwVKH-wZThcy470EOGwqARqX73KQug7WxyWcftFwOzjz5h_yoL0dYOGZTR9ehftnT20ZVrYUWnaP7yBPkt21958IIVA9Jx_sGLze5L12Ywmbf1aTWjASw=w1920-h1080'
  },
  {
    id: 56,
    source: 'https://lh3.googleusercontent.com/EAJRpbdXNSZxVAUUiwDt0rzI1WiuazSyMB6aarBgujN2V3B64w8Sc-FN4P5wCVI16xklZxTBintJ2ApdbvtzIUM5ZBmUVk4KET2DHSZlbl3lEIh1DR-Q8d-BgTdozLV1XXDLUk4qHxQ=w1920-h1080'
  },
  {
    id: 57,
    source: 'https://lh3.googleusercontent.com/_0x1CN7uiPm8fy6m9b-4fzQMvGFa0GLzdfNtiq0Cy4_znO8-1n-Mzk692e8qnIdyaWiSCVqT0xorsB5oEvUPN5yb_8hNYpwQfW3nym8-WDYHRlXVmsLWh44XAQqwl3rj16Lt_dcHh8Q=w1920-h1080'
  },
  {
    id: 60,
    source: 'https://lh3.googleusercontent.com/dE6UzWy5uvcxLmHd5IH9F-aOaiIZ5aZbD5I7K7rztLQzYbIIfpynl0T3pErQTXDd8A43CcoCEJ7OkYpt1jCxAv-CpdyTJHYbNffTlgw5pxogZhqYnsejQoslBHHIpwNn3hpjf8wZjyc=w1920-h1080'
  },
  {
    id: 61,
    source: 'https://lh3.googleusercontent.com/u0L559qtU7o_nm0H4IUNeChOQHjmAeg1UxJjybtEiojHFs98lTe0ZUioo_5PdUbe_eLuTs5Wh0b7R5UlGvGw_gK4wuRPwA_U-kmK6guQXBbt0TcXBb81Ms2fltL8pg9pb1ODzfbf4h8=w1920-h1080'
  },
  {
    id: 63,
    source: 'https://lh3.googleusercontent.com/ED1MeApCXIcAhXuzb1OzMNbSouOXbTZSkT4HN0HUa6xjUop2x_MfQ99ONhE6hfbGbshK-0oc5n8TuhuTjDYKe_N4N_OGujaL7kJZ9dpDy4B-PVHKpqe7FpbJVJvDd4hp0CE4G-2lYQQ=w1920-h1080'
  },
  {
    id: 64,
    source: 'https://lh3.googleusercontent.com/e1cSgkYh6c8m_u89xZBrW0g2rh6EQ9LUc_aUbioEgxdVMLq044q_R3rhU0Dd1YYNKg1gEkSv1KwRc2VcUhulcJgN5iQHPVl6d-pL3qJKFEkyN-w6AxSqXxp0mHnrNG4JnHAuzuio8nc=w1920-h1080'
  },
  {    
    id: 65,
    source: 'https://lh3.googleusercontent.com/90HATzfn9hI2wtjoUTf0V-WH_P9rh6gbe7GFYtmL1rK89ZRj75RLvDofEc238a2saa-pm8J1HeZTT6PcsAyO26u8LRT7BlfJpHwH1fcFQbCKMvTw2VBBNfmHnxRcmxysFHJtsPK3dI4=w1920-h1080'
  },
  {
    id: 66,
    source: 'https://lh3.googleusercontent.com/YxHQtNI_WK3CzomL0bs-65K1FT7ERP3XfTaTfStr13I_Dfk0g0h07Qd_0Xjtw1i2Fam4DgrvCBILhYt_kZFqtPvYRXKbZHI-woAqtjHoLXX6y-80IthNn3OINcwkOQFtvrh-OFN_fGY=w1920-h1080'
  },
  {
    id: 67,
    source: 'https://lh3.googleusercontent.com/8DHxoUQIb_ClormCI8hWr409uc-Yr3Gp0lz9hzRWIJaaBivMTM6FgW5U7tgMBTyTHeoWuP1qeBs9mKGPzwnGkiWt3kQOGgSQSPYfFxR2cFd8nhPpaGF3VpQiP-69FdUy25KJoj0qXEY=w1920-h1080'
  },
  {
    id: 68,
    source: 'https://lh3.googleusercontent.com/qp7e_m3qoAlbagfBw_pcVVFm9HRHe4Gu65MHtHm7Ccfgw5PzyUqkNbyb4qbhKL5bWVXcrySUeaUM306a0JN1Lb-UO4lJLp5BPVRcq7dtxj6U7kxMMQgjEbPToYeO6__ZNousFjqWdLQ=w1920-h1080'
  },
  {
    id: 69,
    source: 'https://lh3.googleusercontent.com/ENP47_hfQdZ3NqyWBgp8ScIa8GHEsteZXWl9Ea3LEV5X6or0bqZ06-EiBQ7asjZWpvb2lktyHpvjcx0afidXuWQWBTS64EMlxVzEUBfM1ByYLzkb40rsUEtMT7jD5C-XcGSCRg91puA=w1920-h1080'
  },
  {
    id: 70,
    source: 'https://lh3.googleusercontent.com/o4g0PqL5sa47DRiPICer8kgpgM5XM05DHXsJ5smxbibV3R5TigL8ql1C5pZc5cbJqf9vKowdQNV1ms_N_3Yp1mcMbEWbzL8Ha01AOQLuzpNchG3N4BdmeFdUnZnv5Xqpceu-ofXlJBE=w1920-h1080'
  },
  {
    id: 71,
    source: 'https://lh3.googleusercontent.com/4X8Lo0c9apGGyiZgZb-cWIRhD75-RWVvwXbKzohJVAi2N3ME7Vf7Gy7fMy0swFsXoQfsKCNXI-NaI_HPC4uCozvZRqbaG0wL4_Or6UmJntNWISbR6uWfM1iQqXea5bFBrCBSMiMGXtw=w1920-h1080'
  }
]
}